export default "__VITE_ASSET__DQuSiSKj__"